import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import CustomButton from "../../shared/CustomButton"
import { Navigation } from "swiper/modules"
import { useContext, useEffect, useState } from "react"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import FacilitiesAmenitiesHeader from "./FacilitiesAmenitiesHeader"
import FacilitiesArrows from "./FacilitiesArrows"
import { useNavigation } from "@/app/hooks/useNavigation"
import FacilityCard from "./FacilityCard"

const FacilitiesAmenities = ({ data }: any) => {
	const router = useNavigation()
	
	const { isIpad } = useContext(screenSizeContext)
	const [facilities, setFacilities] = useState([])
	const canLoop = facilities.length >= 3

	useEffect(() => {
		setFacilities(data?.children?.sort((a: { order: number }, b: { order: number }) => a.order - b.order))
	}, [data])

	//  lg:h-[101vh]
	return (
		<div className="FacilitiesAmenities lg:mt-[11rem] lg:mb-[5.5rem]">
			<div className="w-full h-full overflow-hidden lg:px-8">
				<FacilitiesAmenitiesHeader title={data.title.en} description={data.description.en} />
				<div className="FacilitiesAmenities-content || relative">
					<Swiper
						spaceBetween={isIpad ? 18 : 24}
						slidesPerView={isIpad ? 1.2 : 1.5}
						centeredSlides
						loop={canLoop}
						initialSlide={1}
						navigation={{
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						}}
						modules={[Navigation]}
					>
						{[...facilities,...facilities]?.map((item: any, index: number) => (
							<SwiperSlide key={+index + item.id}>
								<FacilityCard item={item} />
							</SwiperSlide>
						))}
					</Swiper>
					<FacilitiesArrows />
				</div>
				<div className="px flex justify-center w-full mx-auto mt-10">
					<CustomButton
						text={data?.button_1_text?.en || "Learn More"}
						action={() => router.push(data.button_1_url || "/amenities")}
						hasIcon style="grey"
					/>
				</div>
			</div>
		</div>
	)
}

export default FacilitiesAmenities
